
import { gsap } from "gsap";
import { Draggable } from "gsap/Draggable";
import { TextPlugin } from "gsap/TextPlugin";
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';
import MotionPathPlugin from "gsap/MotionPathPlugin";
import ScrollTrigger from "gsap/ScrollTrigger";
import { CSSRulePlugin } from "gsap/CSSRulePlugin";
gsap.registerPlugin(Draggable, TextPlugin, DrawSVGPlugin, MotionPathPlugin, ScrollTrigger, CSSRulePlugin);
gsap.defaults({ ease: 'power1.out' })
export * from "gsap";
export * from "gsap/Draggable";
export * from "gsap/TextPlugin";
export * from "gsap/DrawSVGPlugin";
export * from "gsap/CSSRulePlugin";